import React from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Icon } from 'antd'

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class AlertPopup extends React.Component {
    onClose = () => {
        this.props.popupStore.togglePopup(false)
    }

    render() {
        const {
            popupStore: {
                popupType,
                info: { title, body }
            }
        } = this.props

        const visible = ['alert', 'error', 'success'].includes(popupType)

        const symbols = {
            alert: 'exclamation-circle',
            error: 'warning',
            success: 'check'
        }

        let colors = {
            alert: '',
            error: 'red',
            success: 'green'
        }

        const iconType = symbols[popupType as keyof typeof symbols]
        const iconColor = colors[popupType as keyof typeof colors]

        const isPrepaymentAlert = title === 'התראה על התשלום מראש'

        const bodyStyle: React.CSSProperties = { ...style.body }
        const titleStyle: React.CSSProperties = { ...style.title }

        if (isPrepaymentAlert) {
            bodyStyle.gap = '15px'
            titleStyle.marginBottom = '0em'
        }

        const prepaymentIconColor = isPrepaymentAlert ? 'red' : iconColor

        return (
            <Modal visible={visible} onCancel={this.onClose} footer={false}>
                <div style={bodyStyle}>
                    {isPrepaymentAlert && (
                        <Icon type={iconType} style={{ fontSize: '36px', color: prepaymentIconColor }} />
                    )}
                    <p style={titleStyle}>{title}</p>
                    <p style={{ ...style.content, whiteSpace: 'pre-wrap' }}>{body}</p>
                    {popupType !== 'alert' && <Icon type={iconType} style={{ fontSize: '36px', color: iconColor }} />}
                </div>
            </Modal>
        )
    }
}

export default AlertPopup

const style: { body: React.CSSProperties; title: React.CSSProperties; content: React.CSSProperties } = {
    body: {
        display: 'flex',
        flexDirection: 'column' as const,
        alignItems: 'center',
        padding: '40px 0 30px 0'
    },
    title: {
        fontSize: '20px',
        textAlign: 'center'
    },
    content: {
        fontSize: '16px',
        textAlign: 'center'
    }
}
